module.exports = __webpack_public_path__ + "img/103.30091c43.png";